import {
  CmpSelectBox,
  CmpTextField,
  CmpButton,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fcovertToNumber, fErrorMessage } from "../../Utility/Utilitys";
import Notification_Breadcrumbs from "./Notification_BreadCrumbs";
import {
  fAlertToast,
  Get_ToggleDropDown_binsearch_Load,
  GetGitterColumns,
} from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  GridDataVarianceColumns_Def,
  GridDetailData_Def,
  MultiCardFlag,
  WMS_PICKING_DROP_ID_Flag,
} from "./Action";
import {
  NotificationPickingPending_Status_Set,
  NotificationPickingPendingAuto_Init,
} from "./SliceNotification";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./Notification.css";
import { Notification_PickQty_GETROW } from "../../Server/ApiV2";
import GCMultipleCard from "./component/GCMultipleCard";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { NotificationVariance } from "./component/NotificationVariance";
import DetailCardComp, {
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import DashBoardBreadCrumbs from "../WmsDashboard/processComponent/DashBoardBreadCrumbs";
import Picking_Breadcrumbs from "../Picking/Picking_BreadCrumbs";

export default function PickingDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const PickingDetailFocusOnLoad = useRef(null);
  const location = useLocation();
  // const vRdxDetail = useSelector(
  //   (state) => state.SliceNotification.value.NotificationHead
  // );
  // const vRdxDetailObj = useSelector(
  //   (state) => state.SliceNotification.value.NotificationPickingPending
  // );
  //get from data automaticaly from previous page and set sDetail on load
  const vRdxDetailAuto = useSelector(
    (state) =>
      state.SliceNotification.value.NotificationPickingPendingDetailObjAuto
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);
  // Navigate from DashBoard & Picking - Dec 24 2025 by Ramesh Sir
  const headObj = location.state;
  // const detailObj = location.state ?? headObj;
  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sVarianceList, setVarianceList] = useState([]);
  const [sLoading, setLoading] = useState(false);
  const [sGridRow, setGridRow] = useState([]);
  const vInitialstate = {
    SrNo: 0,
    CardId: "",
    ItemCode: "",
    ItemName: "",
    BinCode: "",
    BinName: "",
    Unit: "",
    Qty: 0,
    DropID: vRdxDetailAuto.DropID,
    BaseQty: 0,
    PackQty: "",
    RefNo: vRdxDetailAuto?.SuppRefno1,
  };
  const [sDetail, setDetail] = useState(vInitialstate);
  const [sDetailAuto, setDetailAuto] = useState({
    CardIdAuto: "",
    BinNameAuto: "",
  });
  let SDetailQtyInit = {
    BalQty: 0,
    PickQty: 0,
    PickedQty: 0,
  };
  const [sDetailQty, setDetailQty] = useState(SDetailQtyInit);

  let vErrorMsgInit = {
    SrNo: "",
    CardId: "",
    ItemCode: "",
    ItemName: "",
    BinCode: "",
    BinName: "",
    Unit: "",
    Qty: "",
    DropID: "",
    BaseQty: "",
    PackQty: "",
  };
  const [sErrorMsg, setErrorMsg] = useState(vErrorMsgInit);
  const [sUnitData, setUnitDataArr] = useState([]);

  //MultipleCard start
  const [sMultipleCardModal, setMultipleCardModal] = useState(false);
  const [sMultipleCardData, setMultipleCardData] = useState([]);

  const fOpenMultipleCardModal = () => {
    setMultipleCardModal(true);
  };
  const fMultipleCard = async (e) => {
    // const { HeadObject } = InboundGrn();
    // await GetMultipleCard(
    //   HeadObject.A_RefDocNo,
    //   HeadObject.A_RefDocTyp,
    //   setMultipleCardData

    // );
    fOpenMultipleCardModal();
  };
  const fCloseMultipleCardModal = (e) => {
    setMultipleCardModal(false);
  };
  //MultiCard end

  const [sOpenVarianceModel, setOpenVarianceModel] = useState(false);
  const [sOpenModel, setOpenModel] = useState(false);

  const fCloseModel = () => {
    setOpenModel(false);
  };

  const fOpenModel = () => {
    setOpenModel(true);
  };
  const fCloseVarianceModel = () => {
    setOpenVarianceModel(false);
  };

  const fOpenVarianceModel = () => {
    setOpenVarianceModel(true);
  };

  const fonDoubleClickCloseGrid = (e) => {
    setOpenModel(false);
  };

  const fQtyKey = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      if (WMS_PICKING_DROP_ID_Flag() && sDetail.DropID == "") {
        document.getElementById("DropID")?.focus();
      } else if (sDetail.Qty !== "") {
        fSave();
      }
    }
  };

  const clear_cardId_backspace = () => {
    setDetail((obj) => ({
      ...obj,
      ItemName: "",
      ItemCode: "",
      Unit: "",
      // BinCode: "",
      // BinName: "",
      BaseQty: "",
      PackQty: "",
      // RefNo: "",
    }));
    setDetailQty(SDetailQtyInit);
    setUnitDataArr([]);
  };
  const fCardIdKey = async (e) => {
    // setDetail((obj) => ({ ...obj, Barcode: e.target.value, }));
    if (
      e.key === "Enter" ||
      e.key === "Tab" ||
      e.keyCode === 13 ||
      e.keyCode === 9 ||
      e.keyCode === 299
    ) {
      if (sDetail.CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      }
      if (sDetail.BinCode == "" || sDetail.BinName == "") {
        fAlertToast("FAILED", "BinCode is empty");
        setTimeout(() => {
          document.getElementById("BinName")?.focus();
        }, 100);
      } else if (MultiCardFlag()) {
        GetMultiBarcodeDetail(sDetail.CardId, sDetail.BinCode, false);
      } else {
        if (sDetail.BinCode !== "" && sDetail.BinName !== "") {
          const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
            sDetail.BinName,
            "Any",
            "Y",
            headObj?.A_Loc
          );
          if (vReasonWmBin.length > 0 && vReasonWmBin[0]?.OpenBin == "Y") {
            GetBarcodeDetail(sDetail.CardId, false);
          } else {
            GetCartIDDetail(sDetail.CardId, false);
          }
        }
      }
    } else if (e.key === "Backspace" || e.keyCode === 8) {
      clear_cardId_backspace();
    } else if (e.key === "Delete" || e.keyCode === 46) {
      if (sDetail.CardId == "") {
        clear_cardId_backspace();
      }
    }
  };

  const fOnChangeDetail = (e) => {
    if (
      // e.target.name === "CardId" ||
      e.target.name === "Qty"
    ) {
      if (e.target.value >= 0 || e.target.value === "") {
        setDetail((obj) => ({
          ...obj,
          [e.target.name]: e.target.value,
        }));
      }
    } else {
      setDetail((obj) => ({
        ...obj,
        [e.target.name]: e.target.value,
      }));
    }
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sDetail.CardId.toString().length &&
      vMediaQuery &&
      e.target.name === "CardId"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "") {
        fCardIdKey(vBackspaceObj);
      }
    }
    if (
      e.target.value.length < sDetail.BinName.toString().length &&
      vMediaQuery &&
      e.target.name === "BinName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "") {
        fBinNameKey(vBackspaceObj);
      }
    }
  };

  const fOnChangeDetailBinName = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      CardId: "",
    }));
    clear_cardId_backspace();
    if (
      e.target.value.length < sDetail.BinName.toString().length &&
      vMediaQuery &&
      e.target.name === "BinName"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "") {
        fBinNameKey(vBackspaceObj);
      }
    }
  };
  const fUnitSelect = useCallback(
    (e) => {
      var vUnit = sUnitData.find((obj) => {
        return obj.Unit == e.target.value;
      });
      setDetail((obj) => ({
        ...obj,
        Unit: vUnit.Unit,
        PackQty: vUnit.PackQty,
      }));
      fBaseQty(sDetail.Qty, vUnit.PackQty);
    },
    [sDetail]
  );

  const fOnChangeQty = (e) => {
    setErrorMsg((obj) => ({
      ...obj,
      Qty: "",
    }));
    if (Number(e.target.value) < 0) {
      setDetail((obj) => ({
        ...obj,
        [e.target.name]: Number(e.target.value),
      }));
      setErrorMsg((obj) => ({
        ...obj,
        Qty: "Quantity should not be less then zero",
      }));
    }
    if (e.target.value % 1 != 0) {
      setDetail((obj) => ({
        ...obj,
        [e.target.name]: Number(e.target.value),
      }));
    } else {
      setDetail((obj) => ({
        ...obj,
        [e.target.name]: Number(e.target.value),
      }));
    }
    fBaseQty(e.target.value, sDetail.PackQty);
  };

  const fBinNameKey = async (e) => {
    if (e.key === "Enter") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sDetail.BinName?.toUpperCase(),
        "Any",
        "Y",
        headObj?.A_Loc
      );

      if (vExactSearch.length > 0) {
        setDetail((obj) => ({
          ...obj,
          BinCode: vExactSearch[0].UId,
          BinName: vExactSearch[0].Name1,
        }));
        document.getElementById("CardId")?.focus();
      } else {
        fAlertToast("FAILED", "Wrong BinName");
      }
    }
    const vBinNameReadOnly = document?.getElementById("BinName")?.readOnly;
    if (e.key === "Backspace" && vBinNameReadOnly === false) {
      setDetail((obj) => ({
        ...obj,
        BinCode: "",
        CardId: "",
      }));
      clear_cardId_backspace();
    } else if (e.key === "Delete" && vBinNameReadOnly === false) {
      if (sDetail.BinName == "") {
        setDetail((obj) => ({
          ...obj,
          BinCode: "",
          CardId: "",
        }));
        clear_cardId_backspace();
      }
    }
  };
  const fBaseQty = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setDetail((obj) => ({
      ...obj,
      BaseQty: vBaseQty,
    }));
  };

  const setValidation = () => {
    setErrorMsg(vErrorMsgInit);
    let iRes = true;
    if (sDetail.SrNo === "") {
      setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty" }));
      iRes = false;
    }
    if (sDetail.CardId === "") {
      setErrorMsg((obj) => ({ ...obj, CardId: "CardId is Empty" }));
      iRes = false;
    }
    if (sDetail.BinCode === "") {
      setErrorMsg((obj) => ({ ...obj, BinCode: "BinCode is Empty" }));
      iRes = false;
    }
    if (sDetail.BinName === "") {
      setErrorMsg((obj) => ({ ...obj, BinName: "BinName is Empty" }));
      iRes = false;
    }

    if (sDetail.ItemCode === "") {
      setErrorMsg((obj) => ({ ...obj, ItemCode: "ItemCode is Empty" }));
    }
    if (sDetail.ItemName === "") {
      setErrorMsg((obj) => ({ ...obj, ItemName: "ItemName is Empty" }));
      iRes = false;
    }
    if (sDetail.DropID === "" && WMS_PICKING_DROP_ID_Flag()) {
      setErrorMsg((obj) => ({ ...obj, DropID: "Drop ID is Empty" }));
      iRes = false;
    }
    if (sDetail.Qty === "") {
      setErrorMsg((obj) => ({ ...obj, Qty: "Quantity is Empty" }));
      iRes = false;
    } else if (Number(sDetail.Qty) < 0) {
      setErrorMsg((obj) => ({
        ...obj,
        Qty: "Quantity should not be lesser then zero",
      }));
      iRes = false;
    }
    if (sDetail.Unit === "") {
      setErrorMsg((obj) => ({ ...obj, Unit: "unit is Empty" }));
      iRes = false;
    }
    if (sDetail.BaseQty === "") {
      setErrorMsg((obj) => ({ ...obj, BaseQty: "BaseQty is Empty" }));
      iRes = false;
    }
    if (sDetail.PackQty === "") {
      setErrorMsg((obj) => ({ ...obj, PackQty: "packQty is Empty" }));
      iRes = false;
    }
    if (headObj.A_Typ == "A") {
      if (
        sDetail.CardId != sDetailAuto.CardIdAuto &&
        sDetailAuto.CardIdAuto != ""
      ) {
        setErrorMsg((obj) => ({ ...obj, CardId: "Check Card ID" }));
        iRes = false;
      }
      if (
        sDetail.BinName != sDetailAuto.BinNameAuto &&
        sDetailAuto.BinNameAuto != ""
      ) {
        setErrorMsg((obj) => ({ ...obj, BinName: "Check Bin Name" }));
        iRes = false;
      }
    }
    return iRes;
  };

  const fNew = () => {
    let vDropID = sDetail.DropID;
    setUnitDataArr([]); //unit arr
    setDetail(vInitialstate);
    setDetail((obj) => ({
      ...obj,
      DropID: vDropID,
    }));
    GetLineItems(); //grid
    setErrorMsg(vErrorMsgInit);
    document.getElementById("BinName")?.focus();
    setDetailQty(SDetailQtyInit);
  };
  let timeout = null;
  const fSave = () => {
    setErrorMsg(vErrorMsgInit);
    clearTimeout(timeout);

    timeout = setTimeout(async () => {
      if (setValidation()) {
        GetUpdate();
      }
    }, 800);
  };

  const fDelete = () => {};

  const fPost = () => {
    GetPost();
  };

  const [GridDataVarianceColumns, setGridDataVarianceColumns] = useState(
    GridDataVarianceColumns_Def
  );

  useEffect(() => {
    GetGitterColumns(
      setGridDataVarianceColumns,
      "NOTIFICATION_VARIANCE",
      GridDataVarianceColumns_Def
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GetNotificationPickQty = async (
    VOC_TYP,
    VOC_NO,
    CARID_ID,
    ITEM_CODE
  ) => {
    let iUpdate = {
      VOC_TYP: VOC_TYP,
      VOC_NO: VOC_NO,
      CARID_ID: CARID_ID,
      ITEM_CODE: ITEM_CODE,
    };
    const vUpdate = await Notification_PickQty_GETROW(iUpdate);
    if (vUpdate?.status === 200) {
      console.log(vUpdate?.data?.ResultSet?.TransType);
      setDetailQty((obj) => ({
        ...obj,
        BalQty: vUpdate?.data?.ResultSet[0]?.BalQty,
        PickQty: vUpdate?.data?.ResultSet[0]?.BaseQty,
        PickedQty: vUpdate?.data?.ResultSet[0]?.PickedQty,
      }));
    }
  };

  const fVariance = () => {
    GetVariance();
    fOpenVarianceModel();
  };

  const fGridRowData = async (e) => {
    setDetail((obj) => ({
      ...obj,
      SrNo: e?.row?.G_SrNo,
      CardId: e?.row?.G_CardID,
      ItemCode: e?.row?.G_ItmCd,
      ItemName: e?.row?.ItmName,
      BinCode: e?.row?.G_BinCd,
      BinName: e?.row?.BinName,
      Unit: e?.row?.G_Unit,
      Qty: e?.row?.G_Qty,
      DropID: e?.row?.G_Drop_ID,
    }));
    setDetailAuto((obj) => ({
      ...obj,
      CardIdAuto: e?.row?.G_CardID,
      BinNameAuto: e?.row?.BinName,
    }));
    let UnitArrResp = await GetUnitArr(e?.row?.G_ItmCd);
    if (UnitArrResp.length > 0) {
      let currObj = UnitArrResp.find((obj) => {
        return obj.Unit == e.row.G_Unit;
      });
      setDetail((obj) => ({
        ...obj,
        Unit: currObj.Unit,
        PackQty: currObj.PackQty,
      }));
      fBaseQty(e.row.G_Qty, currObj.PackQty);
    }
  };

  //api NOTIFICATION_PICKINGPOSTING_GETROW
  const GetPost = async () => {
    let vInstantPickingPostingObj = {
      G_VocTyp: headObj?.A_VocTyp,
      G_VocNo: headObj?.A_VocNo,
      UserCd: vRdxuserInfo.UserID,
    };
    const vInstantPickingPosting = await fExecuteAPI(
      "NOTIFICATION_PICKINGPOSTING_GETROW",
      vInstantPickingPostingObj
    );
    if (vInstantPickingPosting?.Type?.toUpperCase() === "SUCCESS") {
      // setDetail((obj) => ({ ...obj, Status: "Completed" }));
      // dispatch(NotificationHead_Status_Set({ Status: "Completed" }));
      dispatch(
        NotificationPickingPending_Status_Set({ A_PKL_DocStatus: "POST" })
      );
      fNew();
      fAlertToast("SUCCESS", "Posted Successfully");
      //navigate("/Notification");
      if (headObj?.entrySource == "Dashboard") {
        navigate("/wmsDashoard");
      } else if (headObj?.entrySource == "Picking") {
        navigate("/Picking");
      } else {
        navigate("/Notification");
      }
    } else {
      fAlertToast("FAILED", fErrorMessage(vInstantPickingPosting));
    }
  };

  const GetVariance = async () => {
    let vInstantPickingVarianceObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
      UserCd: vRdxuserInfo.UserID,
    };
    const vInstantPickingVariance = await fExecuteAPI(
      "NOTIFICATION_PICKINGVARIANCE_GETROW",
      vInstantPickingVarianceObj
    );
    if (vInstantPickingVariance?.Type?.toUpperCase() === "SUCCESS") {
      const vVarianceRows = vInstantPickingVariance.ResultSet?.map(
        (obj, i) => ({ ...obj, id: i + 1 })
      );
      setVarianceList(vVarianceRows);
    } else {
      fAlertToast(
        "FAILED",
        vInstantPickingVariance?.Message ||
          vInstantPickingVariance?.message ||
          vInstantPickingVariance?.response?.data?.message ||
          "Error in Variance"
      );
    }
  };
  //api notdone
  // const GetDelete = async () => {
  //   let vInstantPickingDeleteObj = {
  //     v_PKD_VocTyp: vRdxDetail.PKLstType,
  //     v_PKD_VocNo: vRdxDetail.PKLstNo,
  //     v_PKD_SrNo: sDetail.SrNo,
  //   };
  //   const vInstantPickingDelete = await fExecuteAPI(
  //     "INSTANCE_PICKING_DELETE_GETROW",
  //     vInstantPickingDeleteObj
  //   );
  //   if (vInstantPickingDelete?.Type?.toUpperCase() === "SUCCESS") {
  //     GetLineItems();
  //     fAlertToast("SUCCESS", "Successfully deleted");
  //     fNew();
  //   } else if (vInstantPickingDelete?.Type?.toUpperCase() === "FAILED") {
  //     fAlertToast("FAILED", vInstantPickingDelete.Message);
  //   }
  //   fNew();
  // };

  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetCartIDDetail = async (xCardId, xeditRow) => {
    const CartBarcodeDetailObj = {
      CardId: xCardId,
      // v_Loc: vRdxDetail.Loc,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "NOTIFICATION_PICKINGCARDIDSEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        fCloseMultipleCardModal();
        setDetail((obj) => ({
          ...obj,
          ItemCode: CartBarcodeDetail.ResultSet[0].ItmCd,
          ItemName: CartBarcodeDetail.ResultSet[0].Name2,
          CardId: CartBarcodeDetail.ResultSet[0].CardID,
          // RefNo: CartBarcodeDetail.ResultSet[0]?.SuppRefNo1,
          // BaseQty: CartBarcodeDetail.ResultSet[0].BaseQty
        }));
        await GetNotificationPickQty(
          headObj?.A_VocTyp,
          headObj?.A_VocNo,
          CartBarcodeDetail.ResultSet[0].CardID,
          CartBarcodeDetail.ResultSet[0].ItmCd
        );
        if (CartBarcodeDetail.ResultSet[0].ItmCd !== "" && xeditRow == false) {
          let xUnitArr = await GetUnitArr(CartBarcodeDetail.ResultSet[0].ItmCd);
          if (xUnitArr.length > 0) {
            var vUnit = xUnitArr.find((obj) => {
              return obj.Unit == CartBarcodeDetail.ResultSet[0].Unit;
            });
            if (!!vUnit) {
              setDetail((obj) => ({
                ...obj,
                Unit: vUnit.Unit,
                PackQty: vUnit.PackQty,
              }));
              fBaseQty(sDetail.Qty, vUnit.PackQty);
            } else {
              setDetail((obj) => ({
                ...obj,
                Unit: xUnitArr[0].Unit,
                PackQty: xUnitArr[0].PackQty,
              }));
              fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
              fBaseQty(sDetail.Qty, xUnitArr[0].PackQty);
            }
          }
        }
        setTimeout(() => {
          document.getElementById("Qty")?.focus();
        }, 100);
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          // CardId: "",
          Unit: "",
        }));
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else if (CartBarcodeDetail?.Type === "FAILED") {
      // setDetail((obj) => ({ ...obj, CardId: "" }));
      fAlertToast("FAILED", CartBarcodeDetail.Message);
    } else if (
      CartBarcodeDetail.response.status == 500 ||
      CartBarcodeDetail.response.status == 400
    ) {
      fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
    } else {
      fAlertToast("FAILED", "Error in Loading CardID ");
    }
  };
  const GetBarcodeDetail = async (xBarcode, xeditRow) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_Loc: headObj?.A_Loc,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_TRANSFER_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length > 0) {
        setDetail((obj) => ({
          ...obj,
          ItemCode: vBarcodeDetail.ResultSet[0].ItmCd,
          ItemName: vBarcodeDetail.ResultSet[0].Name2,
          CardId: vBarcodeDetail.ResultSet[0].CardID,
          // RefNo: vBarcodeDetail.ResultSet[0]?.SuppRefNo1,
        }));
        await GetNotificationPickQty(
          headObj?.A_VocTyp,
          headObj?.A_VocNo,
          vBarcodeDetail.ResultSet[0].CardID,
          vBarcodeDetail.ResultSet[0].ItmCd
        );
        if (vBarcodeDetail.ResultSet[0].ItmCd !== "" && xeditRow == false) {
          let xUnitArr = await GetUnitArr(vBarcodeDetail.ResultSet[0].ItmCd);
          if (xUnitArr.length > 0) {
            var vUnit = xUnitArr.find((obj) => {
              return obj.Unit == vBarcodeDetail.ResultSet[0].Unit;
            });
            if (!!vUnit) {
              setDetail((obj) => ({
                ...obj,
                Unit: vUnit.Unit,
                PackQty: vUnit.PackQty,
              }));
              fBaseQty(sDetail.Qty, vUnit.PackQty);
            } else {
              setDetail((obj) => ({
                ...obj,
                Unit: xUnitArr[0].Unit,
                PackQty: xUnitArr[0].PackQty,
              }));
              fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
              fBaseQty(sDetail.Qty, xUnitArr[0].PackQty);
            }
          }
        }
        setTimeout(() => {
          document.getElementById("Qty")?.focus();
        }, 100);
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          // CardId: "",
          Unit: "",
        }));
        fAlertToast("WARNING", "Wrong barcode Id");
      }
    } else if (vBarcodeDetail?.Type?.toUpperCase() === "FAILED") {
      // setDetail((obj) => ({ ...obj, CardId: "" }));
      fAlertToast("FAILED", vBarcodeDetail.Message);
    } else if (
      vBarcodeDetail.response.status == 500 ||
      vBarcodeDetail.response.status == 400
    ) {
      fAlertToast("FAILED", vBarcodeDetail.response.data.message);
    } else {
      fAlertToast("FAILED", "Error in Loading Barcode ");
    }
  };

  const GetMultiBarcodeDetail = async (xBarcode, xBinCd, xeditRow) => {
    const vBarcodeDetailObj = {
      v_Barcode: xBarcode,
      v_BinCd: xBinCd,
      v_Loc: headObj?.A_Loc,
      v_VocTyp: headObj?.A_VocTyp,
      v_VocNo: headObj?.A_VocNo,
    };
    const vBarcodeDetail = await fExecuteAPI(
      "BIN_MULTI_BARCODE_DETAILS",
      vBarcodeDetailObj
    );
    if (vBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (vBarcodeDetail.ResultSet.length == 0) {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          // CardId: "",
          Unit: "",
        }));
        fAlertToast("WARNING", "Wrong barcode Id");
      } else if (vBarcodeDetail.ResultSet.length == 1) {
        GetCartIDDetail(vBarcodeDetail?.ResultSet[0]?.CARDID, false);
      } else if (vBarcodeDetail.ResultSet.length > 1) {
        setMultipleCardData(vBarcodeDetail.ResultSet);
        fMultipleCard();
      }
    } else {
      fAlertToast(
        "FAILED",
        vBarcodeDetail.response.data.message ||
          vBarcodeDetail.Message ||
          "Error in Loading MultiBarcode "
      );
      return;
    }
  };
  //api ITEM_UNIT_INSTANTPICKING_GETROW
  const GetUnitArr = async (xItemCode) => {
    const UnitInfo = await fExecuteAPI(
      "ITEM_UNIT_INSTANTPICKING_GETROW",
      xItemCode
    );
    if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
      if (UnitInfo.ResultSet.length > 0) {
        setUnitDataArr(UnitInfo.ResultSet);
        return UnitInfo.ResultSet;
      }
    } else if (UnitInfo?.Type?.toUpperCase() == "FAILED") {
      setUnitDataArr([]);
      fAlertToast("FAILED", UnitInfo.Message);
      return [];
    } else if (
      UnitInfo?.Type.response.status == 500 ||
      UnitInfo?.Type.response.status == 400
    ) {
      fAlertToast("FAILED", UnitInfo?.Type.response.data.message);
    } else {
      fAlertToast("FAILED", "Error in UnitArr");
    }
  };

  //API NOTIFICATION_PICKINGSAVING_GETROW
  const GetUpdate = async () => {
    setLoading(true);
    let vPickingUpdateObj = {
      G_VocTyp: headObj?.A_VocTyp,
      G_VocNo: headObj?.A_VocNo,
      G_SrNo: sDetail.SrNo,
      G_BinCd: sDetail.BinCode,
      G_BinName: sDetail.BinName,
      G_CardID: sDetail.CardId,
      G_ItmCd: sDetail.ItemCode,
      G_Qty: sDetail.Qty,
      G_Unit: sDetail.Unit,
      G_BaseQty: sDetail.BaseQty,
      G_Type: headObj?.A_Typ == "A" ? "AUTO" : "MANUAL",
      G_Loc: headObj?.A_Loc,
      UserCd: vRdxuserInfo.UserID,
      G_Drop_ID: sDetail.DropID,
    };
    const vPickingUpdate = await fExecuteAPI(
      "NOTIFICATION_PICKINGSAVING_GETROW",
      vPickingUpdateObj
    );

    if (
      vPickingUpdate?.Type?.toUpperCase() === "SUCCESS" &&
      vPickingUpdate?.ResultSet.length > 0 &&
      vPickingUpdate?.ResultSet[0]?.isVariComp == "Y"
    ) {
      dispatch(
        NotificationPickingPending_Status_Set({ A_PKL_DocStatus: "POST" })
      );
      fNew();
      fAlertToast("SUCCESS", "Posted Successfully");
      navigate("/Notification");
    } else if (vPickingUpdate?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Saved");
      GetLineItems();
      fNew();
      if (headObj?.A_Typ == "A" && sDetailAuto.CardIdAuto != "") {
        // navigate('/PickingPendingList');
        setDetailAuto((obj) => ({
          ...obj,
          CardIdAuto: "",
          BinNameAuto: "",
        }));
        dispatch(NotificationPickingPendingAuto_Init());
      }
      fPrevious();
    } else {
      fAlertToast(
        "FAILED",
        vPickingUpdate?.response?.data?.message ||
          vPickingUpdate.Message ||
          "Error in Saving"
      );
    }
    setLoading(false);
  };
  //API NOTIFICATION_PICKINGLINEDETAIL_GETROW
  const GetLineItems = async () => {
    setLoading(true);
    let vLineItemObj = {
      VocTyp: headObj?.A_VocTyp,
      VocNo: headObj?.A_VocNo,
    };
    const vLineItem = await fExecuteAPI(
      "NOTIFICATION_PICKINGLINEDETAIL_GETROW",
      vLineItemObj
    );
    if (vLineItem?.Type?.toUpperCase() === "SUCCESS") {
      if (vLineItem.ResultSet.length > 0) {
        const itemRows = vLineItem.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setGridRow(itemRows);
      } else {
        setGridRow([]);
      }
    } else if (vLineItem?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vLineItem.Message);
    }
    setLoading(false);
  };

  const fonLoad = async (e) => {
    if (vRdxDetailAuto.CardID !== "") {
      setDetailAuto((obj) => ({
        ...obj,
        CardIdAuto: vRdxDetailAuto.CardID,
        BinNameAuto: vRdxDetailAuto.BinName,
      }));
    }
    GetLineItems();
    // if refresh then value in form should clear
    // dispatch(NotificationPickingPendingAuto_Init());
  };

  useEffect(() => {
    fonLoad();
  }, []);

  const [GridDetailData, setGridDetailData] = useState(GridDetailData_Def);

  // useEffect(() => {
  //   GetGitterColumns(
  //     setGridDetailData,
  //     "NOTIFICATION_DETAIL",
  //     GridDetailData_Def
  //   );

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const fPrevious = async (e) => {
    if (headObj?.A_Typ == "A" || headObj?.A_Typ == "M") {
      //detailObj for pickingPendingList (make resuable) by Ramesh Sir on Dec 26 2025
      navigate("/PickingPendingList", {
        state: {
          ...location.state,
          current: "PickingDetail",
        },
      });
    }
    // if (headObj.A_Typ == "M") {
    //   navigate("/PickingHead");
    // }
  };

  const fClear = async (e) => {
    let vDropID = sDetail.DropID;
    setUnitDataArr([]); //unit arr
    setDetail(vInitialstate);
    GetLineItems(); //grid
    setErrorMsg(vErrorMsgInit);
    setDetail((obj) => ({
      ...obj,
      DropID: vDropID,
    }));
  };

  // const fkeyup = async (e) => {
  //     if (e.keyCode === 13) {
  //         alert('Enter');
  //     }
  // }

  // useEffect(() => {
  //     document.addEventListener('keyup', fkeyup, false);
  //     return () => {
  //         document.removeEventListener('keyup', fkeyup, false);
  //     };
  // }, []);
  useEffect(() => {
    PickingDetailFocusOnLoad.current?.focus();
  }, []);
  const buttonStyle1 = {
    background: "red",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle2 = {
    background: "green",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle3 = {
    background: "indigo",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle4 = {
    background: "gray",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };

  return (
    <div className="container-fluid  ">
      <div>
        {headObj?.entrySource == "Dashboard" ? (
          <DashBoardBreadCrumbs />
        ) : headObj?.entrySource == "Picking" ? (
          <Picking_Breadcrumbs />
        ) : (
          <Notification_Breadcrumbs />
        )}
      </div>
      <div style={{ margin: "auto", width: "100%" }}>
        <Grid container columnSpacing={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
          <Grid item xs={12} sm={6} md={3.5} lg={3.1}>
            <Box
              sx={{ flexGrow: 1, display: "none" }}
              className="xs-instant-picking-detail-label"
            >
              <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
                <Grid item xs={24} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 10, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2}>
                      <label className="title-f ">Doc?.Type</label>
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Doc?.Type"}
                        xVariant={"standard"}
                        xValue={headObj.A_VocTyp}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"PKLstType"}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Doc.Name"}
                        xVariant={"standard"}
                        xValue={headObj.VocName}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"PKLstName"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 2, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2}>
                      <label className="title-f ">Doc.No</label>
                    </Grid>
                    <Grid item xs={10}>
                      <CmpTextField
                        xLabelText={"Doc.No"}
                        xVariant={"standard"}
                        xValue={headObj.A_VocNo}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"PKLstNo"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={24} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 10, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2}>
                      <label className="title-f ">Virtl</label>
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Virtl Bin Code"}
                        xVariant={"standard"}
                        xValue={headObj.LoadingBayCode}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"VirtlBinCd"}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"Virtl Bin Name"}
                        xVariant={"standard"}
                        xValue={headObj.LoadingBayName}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"VirtlBinName"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 2, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2}>
                      <label className="title-f ">Type</label>
                    </Grid>
                    <Grid item xs={10}>
                      <CmpTextField
                        xLabelText={"Type"}
                        xVariant={"standard"}
                        xValue={headObj.A_Typ == "A" ? "AUTO" : "MANUAL"}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"Type"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={24} sm={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 10, sm: 12, md: 12 }}
                  >
                    <Grid item xs={2}>
                      <label className="title-f ">Status</label>
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"PikLstSt"}
                        xVariant={"standard"}
                        xValue={headObj.A_DocStat}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"PikLstSt"}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <CmpTextField
                        xLabelText={"PikingSt"}
                        xVariant={"standard"}
                        xValue={headObj.A_PKL_DocStatus}
                        xOnChange={""}
                        xReadOnly={true}
                        xType={"text"}
                        xName={"PickingSt"}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <br></br>
            <Grid
              container
              spacing={0.5}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              className="mb-3 buttonstyle"
            >
              <Grid item xs={6} sm={6} md={7.2} lg={6} textAlign={"center"}>
                {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Pick Qty=" + sDetailQty.PickQty}
                /> */}
                <Button size="small" style={buttonStyle1}>
                  DocNo &nbsp; {headObj.A_VocNo}
                </Button>
              </Grid>

              <Grid item xs={6} sm={6} md={4.8} lg={6} textAlign={"center"}>
                {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Pick Qty=" + sDetailQty.PickQty}
                /> */}
                <Button size="small" style={buttonStyle3}>
                  PickQty &nbsp; &nbsp; {sDetailQty.PickQty}
                </Button>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} textAlign={"center"}>
                {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Picked Qty=" + sDetailQty.PickedQty}
                /> */}
                <Button size="small" style={buttonStyle4}>
                  PickedQty &nbsp; &nbsp; {sDetailQty.PickedQty}
                </Button>
              </Grid>
              <Grid item xs={6} sm={6} md={6} lg={6} textAlign={"center"}>
                {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Balance Qty=" + sDetailQty.BalQty}
                /> */}
                <Button size="small" style={buttonStyle2}>
                  BalanceQty &nbsp; &nbsp;{sDetailQty.BalQty}
                </Button>
              </Grid>
            </Grid>

            <Box sx={{ flexGrow: 1, mt: 3 }}>
              <Grid
                container
                spacing={2}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              >
                {/* <Grid item xs={6} sm={4} md={2}>
                <CmpTextField
                  xLabelText={"Sr.No"}
                  xVariant={"outlined"}
                  xValue={sDetail.SrNo}
                  xOnChange={""}
                  xReadOnly={true}
                  xType={"number"}
                  xName={"SrNo"}
                  xError={sErrorMsg.SrNo === "" ? false : true}
                  xErrorMessage={sErrorMsg.SrNo}
                />
              </Grid> */}
                {/* <Grid item xs={6} sm={4} md={4}>
                <CmpTextField
                  xLabelText={"Bin Code"}
                  xVariant={"outlined"}
                  xValue={sDetail.BinCode}
                  xOnChange={(event) => fOnChangeDetail(event)}
                  xReadOnly={true}
                  xType={"text"}
                  xName={"BinCode"}
                  xError={sErrorMsg.BinCode === "" ? false : true}
                  xErrorMessage={sErrorMsg.BinCode}
                />
              </Grid> */}
                <Grid
                  item
                  xs={6}
                  sm={12}
                  md={headObj?.A_Typ == "A" ? 12 : 12}
                  lg={headObj?.A_Typ == "A" ? 12 : 12}
                  className={headObj?.A_Typ == "A" ? "" : "hideCardidAuto"}
                >
                  <CmpTextField
                    xLabelText={"Bin Name Auto"}
                    xVariant={"outlined"}
                    xValue={sDetailAuto.BinNameAuto}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BinNameAuto"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={headObj?.A_Typ == "A" ? 6 : 6}
                  lg={headObj?.A_Typ == "A" ? 12 : 12}
                >
                  <CmpTextFieldEnter
                    xref={PickingDetailFocusOnLoad}
                    xLabelText={"Bin Name"}
                    xVariant={"outlined"}
                    xValue={sDetail.BinName}
                    xOnChange={(event) => fOnChangeDetailBinName(event)}
                    xReadOnly={sDetail.Unit !== "" ? true : false}
                    xType={"text"}
                    xName={"BinName"}
                    xId={"BinName"}
                    xOnKeyUp={(e) => {
                      fBinNameKey(e);
                    }}
                    xError={sErrorMsg.BinName === "" ? false : true}
                    xErrorMessage={sErrorMsg.BinName}
                    xOnEnter={(e) => {
                      fBinNameKey(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={headObj?.A_Typ == "A" ? 6 : 6}
                  lg={headObj?.A_Typ == "A" ? 12 : 12}
                  className={headObj?.A_Typ == "A" ? "" : "hideCardidAuto"}
                >
                  <CmpTextField
                    xLabelText={"Card ID Auto"}
                    xVariant={"outlined"}
                    xValue={sDetailAuto.CardIdAuto}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"CardIdAuto"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={headObj?.A_Typ == "A" ? 6 : 6}
                  lg={headObj?.A_Typ == "A" ? 6 : 6}
                >
                  <CmpTextFieldEnter
                    xLabelText={"Barcode"}
                    xVariant={"outlined"}
                    xValue={sDetail.CardId}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"CardId"}
                    xId={"CardId"}
                    xOnKeyUp={(e) => {
                      fCardIdKey(e);
                    }}
                    xError={sErrorMsg.CardId === "" ? false : true}
                    xErrorMessage={sErrorMsg.CardId}
                    xOnEnter={(e) => {
                      fCardIdKey(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <CmpTextField
                    xLabelText={"Item Code"}
                    xVariant={"outlined"}
                    xValue={sDetail.ItemCode}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"ItemCode"}
                    xError={sErrorMsg.ItemCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.ItemCode}
                  />
                </Grid>
                <Grid item xs={6} sm={12} md={12} lg={12}>
                  <CmpTextField
                    xLabelText={"Item Name"}
                    xVariant={"outlined"}
                    xValue={sDetail.ItemName}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"ItemName"}
                    xError={sErrorMsg.ItemName === "" ? false : true}
                    xErrorMessage={sErrorMsg.ItemName}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <CmpTextField
                    xLabelText={"Qty"}
                    xVariant={"outlined"}
                    xValue={sDetail.Qty}
                    xOnChange={(event) => fOnChangeQty(event)}
                    xReadOnly={false}
                    xType={"number"}
                    xName={"Qty"}
                    xId={"Qty"}
                    xOnKeyUp={(e) => {
                      fQtyKey(e);
                    }}
                    xonFocus={(e) => {
                      if (e.target.value == 0) {
                        setDetail((obj) => ({
                          ...obj,
                          Qty: "",
                        }));
                      }
                    }}
                    xonBlur={(e) => {
                      if (e.target.value == "") {
                        setDetail((obj) => ({
                          ...obj,
                          Qty: (0).toFixed(2),
                        }));
                      }
                    }}
                    xError={sErrorMsg.Qty === "" ? false : true}
                    xErrorMessage={sErrorMsg.Qty}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <CmpSelectBox
                    xLabelText="Unit"
                    xValue={sDetail.Unit}
                    xOnChange={(event) => fUnitSelect(event)}
                    xName={"Unit"}
                    xData={sUnitData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.Unit === "" ? false : true}
                    xErrorMessage={sErrorMsg.Unit}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <CmpTextField
                    xLabelText={"Base Qty"}
                    xVariant={"outlined"}
                    xValue={sDetail.BaseQty}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"number"}
                    xName={"BaseQty"}
                    xError={sErrorMsg.BaseQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BaseQty}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <CmpTextField
                    xLabelText={"Ref.No"}
                    xVariant={"outlined"}
                    xValue={sDetail.RefNo}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BaseQty"}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={8}
                  md={6}
                  lg={6}
                  sx={{ display: WMS_PICKING_DROP_ID_Flag() ? "" : "none" }}
                >
                  <CmpTextField
                    xLabelText={"Drop ID"}
                    xVariant={"outlined"}
                    xValue={sDetail.DropID}
                    xOnChange={(event) => fOnChangeDetail(event)}
                    xReadOnly={vRdxDetailAuto.DropID != "" ? true : false}
                    xType={"text"}
                    xName={"DropID"}
                    xError={sErrorMsg.DropID === "" ? false : true}
                    xErrorMessage={sErrorMsg.DropID}
                  />
                </Grid>
              </Grid>
            </Box>
            <br></br>
            <Box>
              <Grid
                container
                spacing={{ xs: 1, sm: 1, md: 1 }}
                // columns={{ xs: 6, sm: 4, md: 2 }}
                className="text-center picking-detail-btn"
              >
                <Grid item xs={4} md={6} lg={4}>
                  <CmpButton
                    xbtnName="Previous"
                    xOnClick={fPrevious}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} md={6} lg={4}>
                  <CmpButton
                    xbtnName="Clear"
                    xOnClick={fClear}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} md={6} lg={4}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={fSave}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={headObj.A_PKL_DocStatus === "POST"}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  md={4}
                  lg={4}
                  className=" btn-instant-picking-Detail"
                >
                  <CmpButton
                    xbtnName="Detail"
                    xOnClick={fOpenModel}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                  <CmpButton
                    xbtnName="Variance"
                    xOnClick={fVariance}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={4} md={12} lg={4}>
                  <CmpButton
                    xbtnName="Complete"
                    xOnClick={fPost}
                    xVariant="contained"
                    xSize="small"
                    xDisabled={headObj.A_PKL_DocStatus === "POST"}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={8.5} lg={8.9}>
            <div
              style={{
                height: vMediaQuery ? "65vh" : "72vh",
                overflowY: "auto",
                marginTop: "14px",
              }}
              className="xs-instant-picking-detail-grid"
            >
              <Grid container spacing={1} px={1}>
                {Array.isArray(sGridRow) &&
                  sGridRow?.length > 0 &&
                  sGridRow?.map((item, index) => (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                      <DetailCardComp
                        data={item}
                        onClick={(item) => {
                          fGridRowData({ row: item });
                        }}
                        headerLabel={item.ItmName}
                        content={
                          <Grid container spacing={1}>
                            <DetailInputDisplay
                              label="Sr.No"
                              value={item.G_SrNo}
                            />
                            <DetailInputDisplay
                              label=" Card ID"
                              value={item.G_CardID}
                            />
                            <DetailInputDisplay
                              label="Bin.Name"
                              value={item.BinName}
                            />
                            <DetailInputDisplay
                              label=" Qty"
                              value={item.G_Qty}
                            />
                            <DetailInputDisplay
                              label="UnitName"
                              value={item.UnitName}
                            />
                            <DetailInputDisplay
                              label="Item Code"
                              value={item.G_ItmCd}
                            />
                          </Grid>
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </div>
          </Grid>
        </Grid>

        <div className="xs-instant-picking-detail-grid">
          {/* <Box sx={{ height: vMediaQuery ? "70vh" : "40vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                getRowId={(row) => row.id}
                rows={sGridRow}
                columns={GridDetailData}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                experimentalFeatures={{ newEditingApi: false }}
                hideFooter={sGridRow.length < 100}
                onRowClick={fGridRowData}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </Box> */}
        </div>
      </div>
      <Modal
        open={sOpenModel}
        onClose={fCloseModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance detail">
          <div>
            <GCTitleSticky title={"Grid"} onClose={fCloseModel} />
            <Grid container spacing={1} p={2}>
              {Array.isArray(sGridRow) &&
                sGridRow?.length > 0 &&
                sGridRow?.map((item, index) => (
                  <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                    <DetailCardComp
                      data={item}
                      onClick={(item) => {
                        fGridRowData({ row: item });
                      }}
                      headerLabel={item.ItmName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay label="Sr.No" value={21} />
                          <DetailInputDisplay
                            label=" Card ID"
                            value={item.G_CardID}
                          />
                          <DetailInputDisplay
                            label="Bin.Name"
                            value={item.BinName}
                          />
                          <DetailInputDisplay label=" Qty" value={item.G_Qty} />
                          <DetailInputDisplay
                            label="UnitName"
                            value={item.UnitName}
                          />
                          <DetailInputDisplay
                            label="Item Code"
                            value={item.G_ItmCd}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>
        </Box>
      </Modal>
      <Modal
        open={sOpenVarianceModel}
        onClose={fCloseVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <div>
            <GCTitleSticky title={"Variance"} onClose={fCloseVarianceModel} />
            <NotificationVariance data={sVarianceList} onClick={() => {}} />
          </div>
        </Box>
      </Modal>

      <GCMultipleCard
        xOpen={sMultipleCardModal}
        fCloseDetailModal={fCloseMultipleCardModal}
        sMultipleCard={sMultipleCardData}
        xTitle={"Card Detail"}
        onClickMultipleCard={(obj) => {
          GetCartIDDetail(obj.CARDID, false);
        }}
      />
    </div>
  );
}
